// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// 👉 Patch ResizeObserver pour ignorer les erreurs Chrome
const isResizeObserverErr = (message) =>
  typeof message === "string" &&
  (message.includes("ResizeObserver loop") ||
    message.includes("ResizeObserver loop limit exceeded"));

// 1. Patch du constructeur ResizeObserver pour neutraliser l’erreur
window.ResizeObserver =
  window.ResizeObserver ||
  class {
    constructor() {}
    observe() {}
    unobserve() {}
    disconnect() {}
  };

// 2. Filtrage des erreurs dans la console
const origConsoleError = console.error;
console.error = (...args) => {
  if (args.length && typeof args[0] === "string" && isResizeObserverErr(args[0])) {
    return;
  }
  origConsoleError(...args);
};

// 3. Filtrage des erreurs globales
window.addEventListener("error", (e) => {
  if (e.message && isResizeObserverErr(e.message)) {
    e.stopImmediatePropagation();
  }
});

// 4. Filtrage des promesses non gérées (cas ResizeObserver sous Chrome)
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason && typeof event.reason.message === "string" && isResizeObserverErr(event.reason.message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// Tu peux activer pour PWA si besoin
serviceWorkerRegistration.unregister();
